import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE = "https://regnav.in";

const META = {
  "/": {
    title: "RegNav - Regulatory Approval Roadmaps for Indian Power Projects | Every approval. Every department. One roadmap.",
    description: "Map every statutory and regulatory approval your Indian solar, wind, BESS or transmission project needs — documents, timelines, departments and sequence, in 60 seconds. Free by Solarian.",
  },
  "/wizard": {
    title: "Approval Roadmap Wizard — Map Your Power Project Approvals | RegNav",
    description: "Answer a few questions about your solar, wind, BESS or transmission project and get its complete regulatory approval roadmap — every clearance, document and timeline.",
  },
  "/analyzer": {
    title: "Green Power Switch Analyzer — Rooftop vs Open Access vs Captive | RegNav",
    description: "Enter four numbers from your electricity bill and compare rooftop solar, third-party open access, captive and green tariff — savings, eligibility and approvals for your state.",
  },
  "/login": {
    title: "Log in | RegNav — by Solarian",
    description: "Log in to RegNav to open your saved power project approval roadmaps.",
  },
  "/signup": {
    title: "Create a Free Account | RegNav — by Solarian",
    description: "Create a free RegNav account to save projects, download branded PDF roadmaps and track approvals for your Indian power project.",
  },
};

const NOINDEX = ["/projects", "/admin", "/complete-profile", "/roadmap"];

export function RouteSeo() {
  const { pathname } = useLocation();
  const meta = META[pathname];
  const noindex = NOINDEX.some((p) => pathname === p || pathname.startsWith(p + "/"));
  if (!meta && !noindex) return null;
  return (
    <Helmet>
      {meta && <title>{meta.title}</title>}
      {meta && <meta name="description" content={meta.description} />}
      {meta && <link rel="canonical" href={`${SITE}${pathname === "/" ? "/" : pathname}`} />}
      {meta && <meta property="og:title" content={meta.title} />}
      {meta && <meta property="og:description" content={meta.description} />}
      {meta && <meta property="og:url" content={`${SITE}${pathname === "/" ? "/" : pathname}`} />}
      {noindex && <meta name="robots" content="noindex,nofollow" />}
    </Helmet>
  );
}
